import script from "./DefaultHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultHeader.vue?vue&type=script&setup=true&lang=js"

import "./DefaultHeader.vue?vue&type=style&index=0&id=c24c08f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c24c08f4"]])

export default __exports__